import {NEXT_PERIOD, PREV_PERIOD, SET_PERIOD} from "./constants"

export const goToNextWeek = function(){
  return {
     type: NEXT_PERIOD
  }
}

export const goToPrevWeek = function(){
  return {
     type: PREV_PERIOD
  }
}

export const setPeriod = function(period){

  return {
    type: SET_PERIOD,
    period
  }
}
